/* eslint-disable @typescript-eslint/member-ordering */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { BudgetPreferences, IBudgetsSetting } from '@tacliatech/types';
import { BudgetService } from '@web-frontend/shared/services/budgets';

import { Subscription } from 'rxjs';
import {
  BudgetCalculationsService,
  SummaryTotal,
} from '../../budget-calculations.service';
import { BudgetUtilisService } from '@web-frontend/shared/services/budgets/budgetUtilis.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'roma-total-footer',
  templateUrl: './budget-total.component.html',
  styleUrls: ['./budget-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetTotalComponent implements OnInit {
  /*   INPUTS
 ..............................................*/

  @Input()
  settings: IBudgetsSetting;
  preferences = new BudgetPreferences();

  @Input()
  form: FormGroup;
  budgetCategories: AbstractControl;

  @Input()
  mode: 'ADD' | 'EDIT' = 'ADD';

  /*   PROPERTIES
 ..............................................*/

  private sub$ = new Subscription();

  totals: SummaryTotal;

  zones = this.budgetService.findAllZones();
  currencys = this.budgetService.findAllCurrencys();
  numbers_format = this.budgetService.findAllNumberFormats();
  decimals = this.budgetService.findAllDecimals();
  dates_formats = this.budgetService.findAllDateFormats();
  langs = this.budgetService.findAllLangs();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private budgetService: BudgetService,
    private budgetCalculationsService: BudgetCalculationsService,
    private budgetUtilService: BudgetUtilisService
  ) {}

  set format_decimals(num) {
    num;
  }
  get format_decimals() {
    const format = this.numbers_format.find(
      (format) => format.id === this.preferences?.number_format
    );
    return format;
  }

  get currencySimbol() {
    const format = this.currencys.find(
      (format) => format.id === this.preferences?.currency
    );
    return format?.value;
  }

  async ngOnInit(): Promise<void> {
    this.watchRefreshItems();
    this.preferences = this.settings
      ? this.settings.budgetPreferences
      : this.preferences;

    this.budgetCategories = this.form.controls.budgetCategories;
    if (this.budgetCategories?.value?.length > 0 && !this.totals) {
      this.totals = await this.budgetCalculationsService.calculateTotalsRealTime(
        this.budgetCategories.value.flat(),
        this.settings
      );
    }
    this.draw();
  }

  private draw() {
    this.changeDetectorRef.detectChanges();
  }

  formatCustomNumber(paramNumber: number): string {
    const formattedNumber = this.budgetUtilService.formatNumber(
      this.settings,
      paramNumber
    );
    return formattedNumber;
  }

  private watchRefreshItems() {
    this.sub$.add(
      this.form.controls['budgetCategories'].valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(async (items) => {
          this.totals = await this.budgetCalculationsService.calculateTotalsRealTime(
            items.flat(),
            this.settings
          );
          this.draw();
        })
    );
  }

  calculateItemDiscount($item) {
    let total = $item.quantity * $item.price;

    if ($item?.discount && $item?.discount !== null) {
      total = $item.quantity * $item.price * (1 - $item?.discount / 100);
    }
    return total;
  }
}
